import { render, staticRenderFns } from "./DataGridBody_v2.vue?vue&type=template&id=62b701eb&scoped=true&"
import script from "./DataGridBody_v2.vue?vue&type=script&lang=js&"
export * from "./DataGridBody_v2.vue?vue&type=script&lang=js&"
import style0 from "./DataGridBody_v2.vue?vue&type=style&index=0&id=62b701eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b701eb",
  null
  
)

export default component.exports